<template>
    <connection-settings-popup
        :is-new="isNew"
        :config="conditionsModel"
        :validations="$options.validations.conditionsModel"
        :resources="{
            deletePromptTitle: resource('JourneyBuilder_Filter_Delete_Title'),
            deletePromptBody: resource('JourneyBuilder_Filter_Delete_Body'),
            deleteButtonText: resource('JourneyComposer_FilterModal_Button_DeleteCheckpoint')
        }"
        :comment-id="commentId"
        
        @save="saveConnection()"
        @delete="deleteCheckpoint()"
        @display-errors="displayErrors()"
        @hidden="$emit('hidden')"
    >
        <template #title>
            <div class="w-100">
                <h3>
                    {{resource('JourneyComposer_FilterModal_Title')}}
                </h3>
            </div>
        </template>

        <template #body>
            <h4>
                {{resource('JourneyComposer_FilterModal_CustomConditionsTitle')}}
                <help-popover
                    :title="resource('JourneyComposer_FilterModal_CustomConditionsTitle')"
                    :content="resource('JourneyComposer_FilterModal_CustomConditions')"
                />
            </h4>

            <brick-filter-settings-editor
                ref="editor"

                :conditions="conditionsModel"
                @conditions-changed="conditionsModel = $event"

                :excluded-category-filters="['Audience', 'NotAudience']"
            />

            <error-message v-if="!$v.conditionsModel.required" :message="resource('JourneyComposer_GroupRequired_ErrorMessage')" />
        </template>
    </connection-settings-popup>
</template>

<script>
    import ResourceMixin from '@core/Util/Mixins/resources'
    import BrickFilterSettingsEditor from "./BrickFilterSettingsEditor";
    import { NewComment } from '@modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Comments';
    import HelpPopover from '@modules/JourneyBuilder/Components/Elements/HelpPopover.vue';
    import conditionExpansion from "./condition-expansion";
    import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';
    import {validationMixin} from 'vuelidate';
    import { required } from 'vuelidate/lib/validators';
    import {conditionGroupValidations} from "./validations";
    import ConnectionSettingsPopup from '../ConnectionSettingsPopup';

    import { filterCheckpoint } from '@modules/JourneyBuilder/Bricks/checkpoint-definitions';
    import ErrorMessage from "@core/Components/Errors/ErrorMessage";

    export default {
        name: 'journey-brick-settings-filter',
        components: {
            ErrorMessage,
            BrickFilterSettingsEditor,
            HelpPopover,
            NewComment,
            ConnectionSettingsPopup
        },
        mixins: [ 
            ResourceMixin, validationMixin, permissionsMixin
        ],
        props: {
            isNew: {
                type: Boolean,
                required: true
            },

            connection: {
                type: Object
            },

            config: {
                type: Object,
                default: () => ({
                    "conditions": [
                        [
                            {
                                "field": null,
                                "value": null
                            }
                        ]
                    ]
                })
            },
        },

        data() {
            return {
                configuration: {
                    conditions: []
                }
            }
        },

        computed: {
            commentId() {
                return "connection:" + this.connection.id + ":" + filterCheckpoint.name;
            },

            conditionsModel: {
                get(){
                    return this.configuration.conditions;
                    //return conditionExpansion.inflate();
                },
                set(value){
                    this.configuration.conditions = value;
                }
            }
        },

        validations: {
            conditionsModel: {
                required,
                ...conditionGroupValidations
            }
        },

        mounted() {
            //Ensure a conditions property 
            // * is present
            // * is reactive
            // * is deep cloned, and does not modify the original object
            
            const configConditions = (this.config.filter && this.config.filter.conditions) || [];
            this.configuration.conditions = conditionExpansion.inflate(configConditions);
        },

        methods: {
            deleteCheckpoint() {
                this.$emit('delete-connection-checkpoint', { connection: this.connection, checkpoint: 'filter' });
            },

            saveConnection() {
                const deflated = conditionExpansion.deflate(this.configuration.conditions);
                
                const mapped = deflated
                    .map(group => group.map(condition => ({ field: condition.field, value: condition.value })));
                
                this.$emit('save', {
                    filter: {
                        conditions: mapped,
                    },
                });
            },
            
            displayErrors(){
                this.$refs.editor.displayErrors();
            }
        },
    }
</script>
